import { mapGetters } from 'vuex';
import { WorkerOnBoardingRoutesMixin } from '@/portal/worker-on-boarding/mixins';

// @vue/component
export default {
  mixins: [
    WorkerOnBoardingRoutesMixin,
  ],
  computed: {
    ...mapGetters({
      businessName: 'workerOnBoarding/selectedBusinessName',
    }),
  },
  created() {
    if (!this.businessName) {
      this.$router.replace(this.routes.businessSearch);
    }
  },
};
